import { realBricksApi } from '../../utils/axiosInterceptors';

export const getEmailPreferences = async () => {
  const response = await realBricksApi.get(`/api/v1/notification`);
  return response.data;
};

export const setEmailPreferences = async (emailPref) => {
  const response = await realBricksApi.put(`/api/v1/notification`, emailPref);
  return response.data;
};
